import React, { forwardRef } from 'react';
import { Button } from './Button';
export const SquareButton = forwardRef(function SquareButton(props, ref) {
    return (React.createElement(Button, Object.assign({ alignItems: "center", display: "flex", isSquare: true, justifyContent: "center", kind: "transparent", px: 0, size: "s", ref: ref }, props)));
});
